import type { ReactNode } from 'react';
import React, { createContext, useContext, useReducer } from 'react';
import type { FormErrorAction, FormErrorState } from '../types';

const initialState: FormErrorState = {
  tabsWithErrors: null,
};

function reducer(state: FormErrorState, action: FormErrorAction) {
  switch (action.type) {
    case 'SET_TABS_WITH_ERRORS':
      return { ...state, tabsWithErrors: action.payload };
    case 'CLEAR_ERRORS':
      return initialState;
    default:
      return state;
  }
}

const FormErrorContext = createContext<{
  state: FormErrorState;
  dispatch: React.Dispatch<FormErrorAction>;
} | null>(null);

export const FormErrorProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <FormErrorContext.Provider value={{ state, dispatch }}>{children}</FormErrorContext.Provider>;
};

export function useFormError() {
  const context = useContext(FormErrorContext);
  if (!context) {
    throw new Error('useFormError must be used within FormErrorProvider');
  }
  return context;
}
